import React, { ReactElement } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { ReportHtml } from '../../elements/ReportHtml'
import { ReportsSkeleton } from '../../elements/ReportsSkeleton'
import { TrialBalance as TrialBalanceNL } from '../NL/trialBalance'
import { TrialBalanceTableActions } from './elements/TrialBalanceTableActions'
import { useTrialBalance } from './hooks/useTrialBalance'

export const TrialBalance = (): ReactElement => {
  const { organization } = useUserOrganization()
  const { report, isLoading, isIdle } = useTrialBalance()

  if (organization?.countryId === 'NL') {
    return <TrialBalanceNL />
  }

  return (
    <>
      <TrialBalanceTableActions />
      {isLoading || isIdle ? <ReportsSkeleton /> : <ReportHtml html={report?.html} />}
    </>
  )
}
